import config from 'config/Config';
import BaseApi from './BaseApi';
import { Request, RequestStatusPatchPayload } from 'types/store/normalized';

export class RequestsApi extends BaseApi<Request> {
  constructor() {
    super(`${config.get('backendURL')}v2/requests`);
  }

  async updateRequest(id: string, payload: Partial<Request>): Promise<Request> {
    return this.update(id, payload);
  }

  /**
   * Status-change PATCH only. Keep the payload type narrow: the backend
   * replaces the stored `data` blob when `data` is present, so accepting a
   * full Partial<Request> here would let callers wipe server-owned data
   * fields (CGP-71).
   */
  async patchRequest(
    id: string,
    payload: RequestStatusPatchPayload
  ): Promise<Request> {
    // Use PATCH /v2/requests/:id endpoint
    const { data } = await this.axiosInstance.patch<Request | Request[]>(
      id,
      payload
    );
    return Array.isArray(data) ? data[0] : data;
  }

  async deleteRequest(id: string): Promise<void> {
    return this.delete(id);
  }
}
